import { render, staticRenderFns } from "./SourceBlacklist.vue?vue&type=template&id=b7629890"
import script from "./SourceBlacklist.vue?vue&type=script&lang=js"
export * from "./SourceBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports